import React from 'react';
import styled from 'styled-components';
import DashboardTemplate from '../../../components/common/DashboardTemplate';
import routes, { redirects } from './routes';
import RouteRedirect from '../../../components/common/RouteRedirect';

const Wrapper = styled.div`
  display: flex;
  flex-flow: column;
  width: 90%;
  margin: auto;
`;

const Home = () => {
  return (
    <DashboardTemplate
      showSubmenu={true}
      stripeHeaderTitle="Dashboards"
      routes={routes}
      redirects={redirects}
      render={(renderPropsData) => (
        <Wrapper>
          <RouteRedirect {...renderPropsData} />
        </Wrapper>
      )}
    />
  );
};

export default Home;
